module.exports = __webpack_public_path__ + "img/logoumfd.3fb1ebc8.png";